<template>
	<div :class="['contact-cards-grid', { 'contact-cards-grid--compact': compact, 'contact-cards-grid--secondary': type === 'secondary' }]">
		<ContactCard @onAccountChange="handleChangeAccount" :shadow="shadow" :customerId="customerId" :showWebAccess="showWebAccess" :compact="compact" v-if="type=='primary'" v-for="c in primaryContacts" v-bind:key="c.id" v-bind:contact="c" v-bind:isIndividual="isIndividual" class="contact-card-item"></ContactCard>
		<div v-if="type=='primary' && primaryContacts.length==0" class="secondary-text fs-14">{{$t('contact.noPrincipalContact')}}</div>
		<ContactCard @onAccountChange="handleChangeAccount" v-if="type=='secondary'" :customerId="customerId" :showWebAccess="showWebAccess" :shadow="shadow" :compact="compact" v-for="c in secondaryContacts" v-bind:key="c.id" v-bind:contact="c" v-bind:secondary="true" class="contact-card-item"></ContactCard>
		<div v-if="type=='secondary' && secondaryContacts.length==0" class="secondary-text fs-14">{{$t('contact.noSecondaryContact')}}</div>
	</div>
</template>
<script>
import ContactCard from '@/components/Contact-card'
export default {
	name: 'ClientCard',
	methods: {
		handleChangeAccount (account) {
			this.$emit('onAccountChange', account);
		},
	},
	computed : {
		primaryContacts(){
			if(this.isIndividual){
				return this.contacts;
			}else{
				return _.filter(this.contacts, c=>{
					return (c.ind_primary && c.active==true)
				})
			}
		},
		secondaryContacts(){
			return _.filter(this.contacts, c=>{
				return ((c.ind_primary==false || c.ind_primary==null) && c.active==true)
			})
		},
		showSecondaryContacts(){
			if(this.contacts==null) return false;
			return this.secondaryContacts.length>0 && !this.isIndividual;
		}
	},
	components : {
		ContactCard
	},
	props: {
		contacts : Array,
		isIndividual : Boolean,
		showWebAccess: {
			type: Boolean,
			default: false,
		},
		type : {
			type : String,
			required : true,
			default : 'primary'
		},
		shadow : {
			type : String,
			default : 'never'
		},
		customerId: {
			type: Number,
		},
		compact: {
			type: Boolean,
			default: false,
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.contact-cards-grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	gap: 8px;
}

.contact-cards-grid--compact ::v-deep .el-card {
	border-radius: 10px;
	border: 1px solid #ebeef5;
}

.contact-cards-grid--compact ::v-deep .card-info {
	margin: 10px 12px 8px;
	min-height: 0 !important;
}

.contact-cards-grid--compact ::v-deep .el-row {
	margin-bottom: 3px;
}

.contact-cards-grid--compact ::v-deep .contact-fiche-info {
	padding-left: 0 !important;
}

.contact-cards-grid--compact ::v-deep .secondary-text.fs-14 {
	font-size: 12px;
	line-height: 1.3;
}

@media screen and (min-width: 1200px) {
	.contact-cards-grid--compact.contact-cards-grid--secondary {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

</style>
